function Logout() {
    sessionStorage.clear('token');
    sessionStorage.clear('tokenExpiresIn');
    localStorage.clear('refreshToken')
    localStorage.clear('refreshTokenExpiresIn')
    window.location.href = "/";
}
export { Logout }
